import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, GuardResult, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services';
import { environment } from '../../../environments/environment';
import { UserRole } from '../models/user-roles.enum';

export function moduleGuard(...moduleRoles: UserRole[]): CanActivateFn {
  return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): GuardResult => {
    const authService: AuthService = inject(AuthService);

    const hasAccess = authService.hasAnyRole([UserRole.GTBETAUser, ...moduleRoles]);
    !hasAccess && (() => { window.location.href = environment.eagleOneUrl })();

    return hasAccess;
  };
}

export const assetIQGuard = moduleGuard(UserRole.GTAssetIQBetaUser);
export const fuelManagementGuard = moduleGuard(UserRole.GTFuelManagementBetaUser);
export const myDriversGuard = moduleGuard(UserRole.GTMyDriversBetaUser);